(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name trainingPrograms.controller:TrainingProgramsCtrl
     *
     * @description
     *
     */
    angular
        .module('trainingPrograms')
        .directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	})
        .controller('TrainingProgramsCtrl', TrainingProgramsCtrl);

    function TrainingProgramsCtrl(CommonMasterData, EventManagerService, TrainingProgramsService, MessageService, CommonLogicService,
                                  applicationConstants, ToolBarService, $timeout, TrainingProgramEditorService, PopupManager, StorageServices) {
        var vm = this;
        vm.view = TrainingProgramsService.getViewName();
        vm.viewType = TrainingProgramsService.getViewType();
        vm.airCraftTypes = [];
        vm.trainingCategories = [];
        vm.openSearchPanel = false;
        vm.searchInitiated = false;
        vm.stationList=[];
        vm.allTrainingLocations=[];

        vm.model={
        	isDeleteSuccess:false,
            multiselected:false,
            selectedTrainingList:[],
            baseAirport:null,
            selectedTraining: TrainingProgramsService.getNewTraining(),
            editorOpenStatus: false,
            searchParams:{
                fromDate: CommonLogicService.getStartEndDateOfRelativeToMonth(null,'NEXT',1,'START'),
                toDate: CommonLogicService.getStartEndDateOfRelativeToMonth(null,'NEXT',1,'END'),
                trainingLocation:TrainingProgramsService.getDefaultTrainingLocation(),
                trainingCategory: TrainingProgramsService.getDefaultTrainingCategory(),
                airCraftType: TrainingProgramsService.getDefaultAircraftType()
            },
            searchFilters:{
                trainingLocation: TrainingProgramsService.getDefaultTrainingLocation(),
                trainingCategory: TrainingProgramsService.getDefaultTrainingCategory(),
                airCraftType: TrainingProgramsService.getDefaultAircraftType(),
                aircraftList:[],
                trainingCategoryList:[],
                locationList:[]
            },
            trainingPrograms:{},
            subToolBar:{
                categories: applicationConstants.TRAINING_COLOR_MAP,
                status:TrainingProgramsService.getTrainingStatusMap()
            },
            trainingCats:[]
        };

        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.VIEW_MODE_CHANGE, changeViewMode);
        EventManagerService.registerEventListener(EventManagerService.EVENT.TRAINING_PROGRAME.GOTO_NEXT_PREVIOUS, gotoNextPreviousPeriod);
        EventManagerService.registerEventListener(EventManagerService.EVENT.TRAINING_PROGRAME.ADD_NEW_TRAINING, addNewTraining);
        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.DELETE_BLOCK, deleteSelection);
        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.DESELECT_ALL, deSelectPairing);


        /**
         * Click on search training programs
         */
        vm.clickSearchTrainingPrograms = function(){
            vm.openSearchPanel = false;
            vm.searchInitiated = true;
            searchTrainingPrograms();
        };

        vm.changeCriteria = function(flag, fieldName){
            if (vm.searchInitiated){
                var tempFilter = {
                    filterKey : flag,
                    filterValue : vm.model.searchFilters[flag],
                    filterField: fieldName
                };
                var filter = TrainingProgramsService.getLocalFilters(tempFilter);
                if(filter!==null){
                    var trainings = TrainingProgramsService.filterTrainingLocally(filter);
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRAINING_PROGRAME.DATA_CHANGED, trainings);
                }else {
                    //searchTrainingPrograms();
                }
            }
        };

        vm.changeDate = function (flag) {
          if((flag.toUpperCase()==='FROMDATE') &&
        		  (!!vm.model.searchParams.toDate && !!vm.model.searchParams.fromDate)){
              var fD = moment(vm.model.searchParams.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
              var eD = moment(vm.model.searchParams.toDate, applicationConstants.SETTINGS.DATE_FORMAT);
              var tempFromDate = moment(vm.model.searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
              if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
            	  vm.model.searchParams.toDate = tempFromDate;
              }
              if(eD.diff(fD) < 0){
                  vm.model.searchParams.toDate = vm.model.searchParams.fromDate;
              }
          }

          if((flag.toUpperCase()==='TODATE') &&
        		  (!!vm.model.searchParams.toDate && !!vm.model.searchParams.fromDate)){
        	  vm.model.searchParams.toDate = vm.model.searchParams.toDate;
          }
        };

        vm.onSelectTraining = function (event, selTraining) {
            selTraining.selectedFlag=!selTraining.selectedFlag;
            if(event.ctrlKey){
                var newList  = TrainingProgramsService.getProcessedSelectedTrainings(vm.model.selectedTrainingList, selTraining);
                vm.model.editorOpenStatus = false;
                vm.model.selectedTrainingList = newList;
                vm.model.multiselected = true;
                if(vm.model.selectedTrainingList.length===1){
                    vm.model.selectedTraining = TrainingProgramEditorService.adeptTrainingWithEditor(vm.model.selectedTrainingList[0]);
                    vm.model.editorOpenStatus = true;
                    vm.model.multiselected = false;
                }
            }else{
                TrainingProgramsService.resetSelectedTrainingPrograms(vm.model.selectedTrainingList);
                selTraining.selectedFlag=true;
                vm.model.selectedTrainingList = [];
                vm.model.selectedTraining = TrainingProgramEditorService.adeptTrainingWithEditor(selTraining);
                vm.model.selectedTrainingList[0] = selTraining;
                vm.model.multiselected = false;

                if(!!selTraining.isRightClick){
                    vm.model.editorOpenStatus = false;
                }else{
                    vm.model.editorOpenStatus = true;
                }
            }
        };

        vm.onCloseEditor = function (status) {
            vm.model.editorOpenStatus = status;
        };

        vm.saveTrainingPrograms = function (saveRequest) {
            doSaveTrainingProgram(saveRequest);
        };

        vm.deleteSelection = function () {
            deleteSelection()
        };

        vm.reSyncSelection = function () {
            reSyncSelection()
        };

        vm.dblClickOnDate = function (selectedDate) {
            console.log(selectedDate);
            gotoSelectedDate(selectedDate);
        };

        function gotoSelectedDate(selectedDate){
            vm.viewType = 'D';
            var newSearchCriteria  = {
                fromDate:selectedDate,
                noOfDays: 0,
                stDate: selectedDate,
                toDate: selectedDate
            };
            var dataForGivenView = TrainingProgramsService.getAvailabilityOfDataNewSearchParams(newSearchCriteria);
            $timeout(function(){
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRAINING_PROGRAME.VIEW_CHANGED, 'D');
                if (dataForGivenView){
                    var trainings = TrainingProgramsService.getTrainingsProgramsForSearchCriteria(newSearchCriteria);
                    var serviceSearchCrit = TrainingProgramsService.getTrainingSearchCriteria();
                    serviceSearchCrit.fromDate = newSearchCriteria.fromDate;
                    serviceSearchCrit.toDate = newSearchCriteria.toDate;
                    TrainingProgramsService.setTrainingSearchCriteria(serviceSearchCrit);
                    TrainingProgramsService.setTrainingPrograms(trainings);
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRAINING_PROGRAME.DATA_CHANGED, trainings);
                    ToolBarService.setToolBarSelectionWithKey('selectedViewButton', 'D');
                    ToolBarService.setButtonConfigsToView(vm.view, TrainingProgramsService.getTraProgramsToolbarConfigs('D'));
                    updateLocalFilters();
                }else{
                    vm.model.searchParams.fromDate = newSearchCriteria.fromDate;
                    vm.model.searchParams.toDate = newSearchCriteria.toDate;
                    searchTrainingPrograms();
                }
            },0);
        }

        function deSelectPairing() {
            TrainingProgramsService.resetSelectedTrainingPrograms(vm.model.selectedTrainingList);
            vm.model.multiselected = false;
            vm.model.editorOpenStatus = false;
        }

        function deleteSelection() {
            var getDeletePrograms = TrainingProgramsService.getTrainingToDelete(vm.model.selectedTrainingList);
            TrainingProgramsService.deleteTrainingPrograms(getDeletePrograms,
                function (response) {
                    if(response.success){
                        MessageService.success(MessageService.MESSAGES.TRAINING_PROGRAME.DELETE_SUCCESS);
                        vm.model.isDeleteSuccess = true;
                        updateView(null);
                    } else {
                        MessageService.error(response.errors[0]);
//                        MessageService.error("Cannot Delete Selected Training Slot(s)as Crew already Assigned [ "+getTrainingSlotsFailedToDelete(response.trainingSlotsFailedToDelete)+" ]" );
                    }
                },
                function (error) {
                	MessageService.error("Error Occured While Deleting Training Program(s)");
                }
            );
            vm.model.multiselected = false;
            vm.model.editorOpenStatus = false;
        }

        function reSyncSelection() {
            var getReSyncPrograms = TrainingProgramsService.getTrainingToReSync(vm.model.selectedTrainingList);
            TrainingProgramsService.reSyncTrainingPrograms(
                { trainingSlotId : getReSyncPrograms.reSyncTrainingSlotList[0].trainingSlotId,
                  trainingProgCategory : getReSyncPrograms.reSyncTrainingSlotList[0].trainingProgCategory,
                  trainingProgramCode : getReSyncPrograms.reSyncTrainingSlotList[0].trainingProgramCode},
                function (response) {
                    if(response.success){
                        MessageService.success(MessageService.MESSAGES.TRAINING_PROGRAME.RESYNC_SUCCESS);
                        updateView(null);
                    }
                },
                function (error) {
                  MessageService.error("Error Occured While ReSync Training Program(s)");
                }
            );
        }

        function getTrainingSlotsFailedToDelete(trainingSlotsFailedToDelete){
        	var trainingsFailedToDelete = "";
        	var training = null;
            if(!!vm.model.selectedTrainingList && !!trainingSlotsFailedToDelete){
            	angular.forEach(trainingSlotsFailedToDelete, function(notDeletedTraining){
            		training = _.find(vm.model.selectedTrainingList, {
            			trainingSlotID : notDeletedTraining.trainingSlotId
                    });
            		if(!!training){
            			trainingsFailedToDelete += (training.slotName +":" + training.startDate + "-" + training.startTime +", ")
            		}
                });
            }
        	return trainingsFailedToDelete;
        }

        function addNewTraining() {
            TrainingProgramsService.resetSelectedTrainingPrograms(vm.model.selectedTrainingList);
            vm.model.selectedTraining = TrainingProgramEditorService.adeptTrainingWithEditor(TrainingProgramsService.getNewTraining());
            vm.model.selectedTraining.hotelCost=0;
            vm.model.selectedTraining.costType="TRAINER";
            if(vm.model.isDeleteSuccess){
            	vm.model.editorOpenStatus = false;
            	vm.model.isDeleteSuccess = false;
            }else{
            	vm.model.editorOpenStatus = true;
            }

         }

        function gotoNextPreviousPeriod(flag) {
            var viewMode = vm.viewType;
            var value = TrainingProgramsService.getNoOfDaysByView(viewMode, vm.model.searchParams.fromDate);
            if(flag.mode==='PREVIOUS'){
                value = -(TrainingProgramsService.getNoOfDaysByView(viewMode, vm.model.searchParams.fromDate));
            }
            var newSearchCriteria = TrainingProgramsService.getDateRangeWithOffset(viewMode, flag.mode, value);
            vm.model.searchParams.fromDate = newSearchCriteria.fromDate;
            vm.model.searchParams.toDate = newSearchCriteria.toDate;
            TrainingProgramsService.setTrainingSearchCriteria(vm.model.searchParams);
            if (vm.searchInitiated){
                $timeout(function(){searchTrainingPrograms();},0);
            }
        }

        function changeViewMode(passedView) {
            vm.viewType = passedView.mode;
            var newSearchCriteria = TrainingProgramsService.getDateRangeWithOffset(passedView.mode, null, 0);
            var dataForGivenView = TrainingProgramsService.getAvailabilityOfDataNewSearchParams(newSearchCriteria);
            TrainingProgramsService.setTrainingSearchCriteria(newSearchCriteria);
            $timeout(function(){
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRAINING_PROGRAME.VIEW_CHANGED, passedView.mode);
                if (dataForGivenView){
                    var trainings = TrainingProgramsService.getTrainingsProgramsForSearchCriteria(newSearchCriteria);
                    TrainingProgramsService.setTrainingPrograms(trainings);
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRAINING_PROGRAME.DATA_CHANGED, trainings);
                    ToolBarService.setToolBarSelectionWithKey('selectedViewButton', passedView.mode);
                    ToolBarService.setButtonConfigsToView(vm.view, TrainingProgramsService.getTraProgramsToolbarConfigs(passedView.mode));
                    updateLocalFilters();
                }else{
                    vm.model.searchParams.fromDate = newSearchCriteria.fromDate;
                    vm.model.searchParams.toDate = newSearchCriteria.toDate;
                    searchTrainingPrograms();
                }
            },0);
        }

        function doSaveTrainingProgram(saveRequest) {
            if(validateBeforeSave(saveRequest)){//Contoroller level validation
                TrainingProgramsService.setSelectedTrainingForSave(saveRequest);
                TrainingProgramsService.saveTrainingProgram(
                    function (response) {
                        if(response.success){

                            if(response.otherHubValidationResponsesList.length > 0){

                              for (var key in response.otherHubValidationResponsesList) {
                                var validationResponse = response.otherHubValidationResponsesList[key];
                                var message = 'Tenant: ' + validationResponse.tenant + ', Validation: ' + validationResponse.validation;
                                MessageService.warning(message);
                              }

                            } else {
                              MessageService.success(MessageService.MESSAGES.TRAINING_PROGRAME.SUCCESS_SAVE);
                            }

                            var searchCriteriaFromSave = TrainingProgramsService.compareSearchCriteriaWithSavedProgram(saveRequest);
                            if (!_.isEmpty(searchCriteriaFromSave)){
                                updateView(searchCriteriaFromSave);
                            }

                          for (var key in response.otherHubSyncResponses) {
                            if (response.otherHubSyncResponses.hasOwnProperty(key)) {
                              if (response.otherHubSyncResponses[key]) {
                                MessageService.success('Tenant: ' + key + ', Status: SUCCESS');
                              } else {
                                MessageService.warning('Tenant: ' + key + ', Status: FAILED');
                              }
                            }
                          }

                        }else{
                            if(response.existConflicts){
                                var conflictsTrainingsModalParams = {};
                                conflictsTrainingsModalParams.conflictsTrainings = response.conflictTrainingSlotDTOList;
                                TrainingProgramsService.setConflictsTrainingPrograms(response.conflictTrainingSlotDTOList);
                                PopupManager.openModal('CONFLICTS_TRAININGS', conflictsTrainingsModalParams, handelConflictsTrainings);
                            }
                        }
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
            }
        }

        function validateBeforeSave(saveRequest) {
            var valid = true;
            //Validate startDate and endDate
            if(saveRequest.fromDate === saveRequest.toDate){
            	valid = true;
            }else if (!CommonLogicService.compareDateTime(saveRequest.fromDate, saveRequest.startTime, saveRequest.toDate, saveRequest.endTime)){
                MessageService.error(MessageService.MESSAGES.TRAINING_PROGRAME.ENDDATE_STARTDATE_CONFLICTS);
                valid = false;
            }
            return valid;
        }

        function handelConflictsTrainings(pass) {
            if (pass==='YES'){
                var saveRequest = TrainingProgramsService.getSelectedTrainingForSave();
                saveRequest.conflictsDateTimes = TrainingProgramsService.getConflictsTrainingPrograms();
                saveRequest.forceAdd = true;
                doSaveTrainingProgram(saveRequest)
            }
        }

        function searchTrainingPrograms(){
            TrainingProgramsService.setTrainingSearchCriteria(vm.model.searchParams);
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRAINING_PROGRAME.VIEW_CHANGED, TrainingProgramsService.getViewType());
            vm.viewType = TrainingProgramsService.getViewType();
            var temp_searchCriteria = TrainingProgramsService.getTrainingSearchCriteria();
            TrainingProgramsService.searchTrainingPrograms(temp_searchCriteria, function(response){
                TrainingProgramsService.setTrainingPrograms(response);
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRAINING_PROGRAME.DATA_CHANGED, response);
                ToolBarService.setButtonConfigsToView(vm.view, TrainingProgramsService.getTraProgramsToolbarConfigs(TrainingProgramsService.getViewType()));
                ToolBarService.setToolBarSelectionWithKey('selectedViewButton', TrainingProgramsService.getViewType());
                updateLocalFilters();
            },function(error){
                MessageService.warning(error);
            });
        }

        function updateLocalFilters(){
            vm.model.searchFilters.locationList = TrainingProgramsService.getFilterTrainingLocations();
            vm.model.searchFilters.aircraftList = TrainingProgramsService.getFilterAircraftModels();
            vm.model.searchFilters.trainingCategoryList = TrainingProgramsService.getFilterTrainingCategories();
            vm.model.searchFilters.trainingCategory =  TrainingProgramsService.getDefaultTrainingCategory();
            vm.model.searchFilters.airCraftType = TrainingProgramsService.getDefaultAircraftType();
            vm.model.searchFilters.trainingLocation = TrainingProgramsService.getDefaultTrainingLocation()
        }

        function updateView(newSearchCriteria){
            //TrainingProgramsService.setViewUpdateSearchCriteria(newSearchCriteria);
            //To update only effected dates
            //var temp_searchCriteria = TrainingProgramsService.getViewUpdateSearchCriteria();
            var temp_searchCriteria = TrainingProgramsService.getTrainingSearchCriteria();
            TrainingProgramsService.searchTrainingPrograms(temp_searchCriteria, function(response){
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRAINING_PROGRAME.DATA_CHANGED, response);
                addNewTraining();
            },function(error){
                MessageService.warning(error);
            });

            TrainingProgramsService.setAndUpdateTrainingPrograms();
        }



        /**
         * Init of the controller
         */
        (function init() {
            vm.baseAirPort = CommonMasterData.getBaseAirport(function (baseAirport) {
                vm.model.baseAirport = baseAirport;
                },function () {}
            );
            CommonMasterData.getAirportList(function(stationList){
                vm.stationList = CommonMasterData.formatAirportList(stationList);
            },function () {});
            //get aircraft list
            CommonMasterData.getAircraftModels(function (airCraftList) {
                vm.airCraftTypes = TrainingProgramsService.setAirCraftTypes(airCraftList);
            }, function (error) {});

            //getAlltrainingLocations
          TrainingProgramEditorService.getAllTrainingLocationByStation(function (locationList) {
            vm.allTrainingLocations = locationList;
            TrainingProgramEditorService.setAllLocationList(vm.allTrainingLocations);
          },function () {});

            //get training categories
            TrainingProgramsService.getTrainingCategories(function(response){
                vm.trainingCategories = response;
                vm.model.trainingCats = response;
                ToolBarService.setButtonConfigsToView(vm.view, TrainingProgramsService.getTraProgramsToolbarConfigs(TrainingProgramsService.getViewType()));
                ToolBarService.setToolBarSelectionWithKey('selectedViewButton', '');
                $timeout(function(){
                    searchTrainingPrograms();
                    vm.searchInitiated = true;
                },0);
            },function(error){})
        })();


        var tabLocalData = StorageServices.getTabData('trainingPrograms');
        if (!!tabLocalData && !!tabLocalData.trainingProgramsParams.startDate) {

            vm.model.searchParams.fromDate = tabLocalData.trainingProgramsParams.startDate;
            vm.model.searchParams.toDate = tabLocalData.trainingProgramsParams.endDate;
            vm.model.searchParams.trainingLocation = TrainingProgramsService.getDefaultTrainingLocation();
            vm.model.searchFilters.trainingCategory = _.filter(vm.model.trainingCats ,function(cat){return _.contains(tabLocalData.trainingProgramsParams.categoryCode,cat.categoryCode)});
            vm.model.searchParams.airCraftType = TrainingProgramsService.getDefaultAircraftType();

            searchTrainingPrograms();

            StorageServices.setTabData('trainingPrograms', 'trainingProgramsParams', {
                startDate: null,
                endDate: null,
                categoryCode:null
            });

            addNewTraining();
            vm.model.selectedTraining.trainingProgramObject = _.filter(vm.model.trainingCats ,function(cat){return _.contains(tabLocalData.trainingProgramsParams.categoryCode,cat.categoryCode)});
         }

    }

    $(window).resize(function(){
    	var height=($("header").height() + $(".tabbed-view-container").height())+"px";
    	$(".training-discrepancy .canvas").css("top", height);
    });
}());
